import React from "react";

import { Box, IconButton, Stack, Tooltip, Typography } from "@mui/material";

import InfoIcon from "@mui/icons-material/Info";

const TitleBox = ({ title, tooltip }) => {
  return (
    <Box>
      <Stack
        direction="row"
        gap={2}
        sx={{
          justifyContent: "space-between", // Spazio tra il titolo e l'icon button
          alignItems: "center", // Allinea verticalmente al centro
          width: "100%", // Assicura che la Stack prenda tutta la larghezza disponibile
        }}
      >
        <Typography variant="h5">{title}</Typography>

        <Tooltip title={tooltip}>
          <IconButton>
            <InfoIcon sx={{ width: 25, height: 25 }} />
          </IconButton>
        </Tooltip>
      </Stack>
    </Box>
  );
};

export default TitleBox;
